import { isArray } from 'util';
import { WarehouseMovementImportSuccess } from '../warehouse-movement-impor-success';

export class WarehouseMovementImportSuccessBuilder {
  static fromJson(json) {
    return (json)
      ? new WarehouseMovementImportSuccess(
        json.success
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(WarehouseMovementImportSuccessBuilder.fromJson) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/warehouse-movement-import-succes.builder.ts